module.exports = __webpack_public_path__ + "static/img/detail-app-user.14bfc272.png";